/**
 * 创建空的视频卡片 payload
 */
export const createEmptyVideoPayload = () => {
  return {
    card_type: 'video',
    type: 'video',
    title: '嵌入內容',
    description: '',
    address: '',
    embed: null, // 用于存储视频嵌入代码/链接
    metaPairs: [],
    tags: [],
    imageUrl: '',
  };
};
